const menuTemplate = (title, renderOptions) => html`
  <fieldset class="space-y-4">
    <div class="px-4 sm:px-6">
      <legend class="text-base font-medium text-gray-500">${title}</legend>
    </div>

    <div>
      ${renderOptions.items
        .map((item) =>
          itemTemplate(item, renderOptions.createURL, renderOptions.widgetParams.attribute)
        )
        .join('')}
    </div>
  </fieldset>
`;

const itemTemplate = (item, createURL, attribute) => html`
  <a
    class="flex items-center py-2 pl-6"
    href="${createURL(item.value)}"
    data-value="${item.value}"
    data-checked="${item.isRefined}"
  >
    <input
      name="${attribute}"
      type="radio"
      value="${item.value}"
      ${item.isRefined ? `checked` : ``}
      class="w-4 h-4 text-primary-600 border-gray-300 focus:ring-primary-500"
    />

    <span class="ml-3">
      <span class="inline-block text-sm">${item.label}</span>
    </span>
  </a>
`;

export default menuTemplate;
